import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Container, IconButton, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ReactNode } from 'react';
import CloseIcon from '../icons/Close';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      padding: pxToRem(18, 24),
      borderBottom: `1px solid #c4c4c4`,
      width: 'inherit',
      justifyContent: 'space-between',
      position: 'fixed',
      zIndex: 1201,
      backgroundColor: 'white',
      maxWidth: 1920,
    },
    drawerCloseIcon: {
      padding: '4px 0 0',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:disabled': {
        opacity: 0.6,
      },
      '& svg': {
        width: pxToRem(18),
        height: 'auto',
      },
    },
    headerText: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    titleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: pxToRem(16),
    },
  }),
);

export interface FormHeaderProps {
  text: string;
  subTitle?: ReactNode;
  handleClose?: () => void;
  disableCrossIconClick?: boolean;
  crossQAPrefix?: string;
  titleAdornment?: ReactNode;
  titleClassName?: string;
}

export const FormHeader = ({
  text,
  handleClose,
  disableCrossIconClick = false,
  crossQAPrefix = '',
  subTitle,
  titleAdornment,
  titleClassName = '',
}: FormHeaderProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Container className={`${classes.root} form-header-container`}>
      <div className={classes.headerText}>
        <div className={classes.titleRow}>
          <Typography className={`form-header ${titleClassName}`} variant="h3" color="textSecondary">
            {text}
          </Typography>
          {titleAdornment}
        </div>
        {subTitle && (
          <Typography variant="body1" color="textSecondary">
            {subTitle}
          </Typography>
        )}
      </div>
      <IconButton
        onClick={handleClose}
        data-testid={crossQAPrefix + 'close'}
        className={classes.drawerCloseIcon}
        disabled={disableCrossIconClick}
        disableFocusRipple
        disableRipple
      >
        <CloseIcon fontSize="small" color="secondary" />
      </IconButton>
    </Container>
  );
};
